import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import FlexPane from '../../../../VentoryUI/components/common/FlexPane';
import SearchBarWithFilter from '../../../../VentoryUI/components/common/SearchBarWithFilter';
import { t } from '../../../../types/translation/Translator';
import Table from '../../../components/Table';
import { ProductMasterDataContext } from '../../../../context/ProductMasterDataContext';
import { CompanyContext } from '../../../../context/CompanyContext';
import { UserContext } from '../../../../context/UserContext';
import { Grid } from '@mui/material';
import { AssetTransactionContext } from '../../../../context/AssetTransactionContext';
import { AssetTransaction } from '../../../../types/asset_transaction/assetTransaction';
import { AssetTransactionFilter } from '../../../../VentoryUI/components/filters/AssetTransactionFilter/AssetTransactionFilter';
import { AssetTransactionTable } from '../../Common/AssetTransactionTable';
import {
  AssetTransactionColumn,
  AssetTransactionTableSettings,
} from '../../../../types/asset_transaction/assetTransaction.table';
import { AssetContext } from '../../../../context/AssetContext';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import { TagRelationContext } from '../../../../context/TagRelationContext';
import { TableSettingsContext } from '../../../../context/TableSettingsContext';
import { EntityType } from '../../../../types/comment';

export default function UserAssetHistoryPane() {
  const { currentCompany } = useContext(CompanyContext);
  const { productMasterData, productMasterDataLoading } = useContext(ProductMasterDataContext);
  const { assetTransactions, assetTransactionsLoading } = useContext(AssetTransactionContext);
  const { assets } = useContext(AssetContext);
  const { getTableSettings } = useContext(TableSettingsContext);
  const { companyUsers, currentUser, locale } = useContext(UserContext);
  const { customFields } = useContext(CustomFieldContext);
  const { tagRelations } = useContext(TagRelationContext);

  const assetTableSettings = getTableSettings(EntityType.asset, currentCompany.id);

  const items = useMemo(() => {
    return [...assetTransactions.values()]
      .filter(transaction => currentUser?.id && transaction.location?.entityId === currentUser.id)
      .sort(
        (a, b) => new Date(b.processedAt || b.createdAt).getTime() - new Date(a.processedAt || a.createdAt).getTime(),
      );
  }, [assetTransactions]);

  const [filteredItems, setFilteredItems] = useState<AssetTransaction[]>(items);

  const columns = [
    {
      index: 0,
      column: AssetTransactionColumn.productName,
      label: t(TranslationKey.assetName).singular.label,
    },
    {
      index: 1,
      column: AssetTransactionColumn.productNumber,
      label: t(TranslationKey.assetNumber).singular.label,
    },
    {
      index: 2,
      column: AssetTransactionColumn.serial,
      label: t(TranslationKey.serial).singular.label,
    },
    {
      index: 3,
      column: AssetTransactionColumn.signedAt,
      label: t(TranslationKey.signedAt).singular.label,
    },
    {
      index: 4,
      column: AssetTransactionColumn.status,
      label: t(TranslationKey.assetStatus).singular.label,
    },
    {
      index: 5,
      column: AssetTransactionColumn.pendingQuantity,
      label: t(TranslationKey.quantity).singular.label,
    },
  ];

  const filter = new AssetTransactionFilter(
    productMasterData,
    companyUsers,
    assets,
    assetTransactions,
    assetTableSettings,
    customFields,
    tagRelations,
    currentCompany,
  );

  return (
    <>
      <FlexPane
        header={
          <SearchBarWithFilter
            loading={assetTransactionsLoading || productMasterDataLoading}
            items={items}
            setItems={setFilteredItems}
            placeholder={t(TranslationKey.searchForAsset).plural.label}
            filter={filter}
          />
        }
        content={
          <Grid container rowSpacing={1} alignContent={'start'} className='h-full'>
            <Grid item xs={12} className='h-full'>
              <Table
                loading={assetTransactionsLoading || productMasterDataLoading}
                items={filteredItems}
                totalItemCount={items.length}
                headers={AssetTransactionTable.header(
                  productMasterData,
                  companyUsers,
                  currentCompany,
                  new AssetTransactionTableSettings({ companyId: currentCompany.id, columns: columns }),
                  locale,
                )}
                filter={filter}
              />
            </Grid>
          </Grid>
        }
      />
    </>
  );
}
